import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  abandonedCheckoutListParams,
  abandonedCheckoutListQueryOptions,
  abandonedCheckoutListSearchSchema,
  AbandonedCheckoutsPage,
} from '@/features/abandoned-checkouts';

export const Route = createFileRoute('/_authed/_active/s/$storeId/abandoned-checkouts/')({
  staticData: { tours: ['abandoned.list'] },
  validateSearch: abandonedCheckoutListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...abandonedCheckoutListQueryOptions(params.storeId, abandonedCheckoutListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch: the URL
    // would lag behind, and a second click in the picker would build on the stale filters.
    if (cause !== 'stay') await prefetch;
  },
  component: AbandonedCheckoutsPage,
});
